import { create } from 'zustand';
import { countModerationQueue, type ModerationQueue } from '@/services/moderationQueue';

const EMPTY: ModerationQueue = { fandomRequests: 0, reports: 0, total: 0 };

interface ModerationState extends ModerationQueue {
  loaded: boolean;
  refresh: () => Promise<void>;
}

/**
 * Lo que espera en moderación, compartido por el menú y el panel.
 *
 * Vive en un store y no en un hook por dentro de cada componente. Antes cada
 * uno tenía su propia copia y la pedía una sola vez al montarse: resolver un
 * pedido actualizaba la solapa pero el punto rojo del menú seguía marcando uno
 * pendiente hasta recargar la página. Un aviso que no se apaga cuando resolvés
 * lo que avisaba deja de significar algo.
 *
 * Sigue sin ser en tiempo real, a propósito: una escucha abierta sobre dos
 * colecciones gastaría lecturas todo el día para avisar de algo que puede
 * esperar. Lo que hace falta es que se vuelva a contar después de cada acción,
 * y eso es una llamada a `refresh()`.
 */
export const useModerationStore = create<ModerationState>((set) => ({
  ...EMPTY,
  loaded: false,

  refresh: async () => {
    try {
      set({ ...(await countModerationQueue()), loaded: true });
    } catch {
      // Que el contador no cargue no puede romper la navegación de nadie.
      set({ loaded: true });
    }
  },
}));
